import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../AppModule/Context';

import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import SuccessIcon from '../../../assets/svgComponents/SuccessIcon';
import WidgetTitleComponent from './widgetTitleComponent';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './widgetsRedirectComponent.css';

const WidgetsRedirectComponent = ({
  isPersonalPage = false,
  mentor = {},
  widgetsRedirectType = null,
  onFooterOptionSelected = () => {},
}) => {
  const context = useContext(AppContext);
  const LANGUAGE_SET = context.languageSet.CONSOLTO_WIDGET;

  const [message, setMessage] = useState('');
  const [widgetsInfo, setWidgetsInfo] = useState([]);

  useEffect(() => {
    const message = getMessage();
    let widgetsInfo = getDefaultWidgetsInfo();

    const widgetsSelectedByMentor =
      mentor.mentorDto?.appControlDto?.[widgetsRedirectType];
    if (widgetsSelectedByMentor?.length) {
      widgetsInfo = [];
      widgetsSelectedByMentor.forEach((widget, idx) => {
        const widgetInfo = {
          type: widget,
          text: getBtnText(widget),
          image: getBtnImage(widget, idx === 0),
        };
        widgetsInfo.push(widgetInfo);
      });
    }

    setMessage(message);
    setWidgetsInfo(widgetsInfo);
  }, [widgetsRedirectType]);

  const getMessage = () => {
    const editableTextKey =
      widgetsRedirectType ===
      VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES.POST_CALL_FAIL_WIDGETS
        ? VIDABOO_CONSTANTS.CALL_FAIL_TYPES_VALUE.CALL_FAIL_MESSAGE
        : VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES_VALUE.FORM_SUBMIT_MESSAGE;
    return mentor?.mentorDto?.appControlDto?.widgetEditableTexts &&
      mentor.mentorDto.appControlDto.widgetEditableTexts[editableTextKey]
      ? mentor.mentorDto.appControlDto.widgetEditableTexts[editableTextKey]
      : widgetsRedirectType ===
          VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES.POST_CALL_FAIL_WIDGETS
        ? context.languageSet.VIDEO_CALL_CAT.IM_NOT_AVAILABLE +
          ' ' +
          context.languageSet.VIDEO_CALL_CAT.LEAVE_MESSAGE +
          ' ' +
          context.languageSet.VIDEO_CALL_CAT.OR +
          ' ' +
          context.languageSet.VIDEO_CALL_CAT.SCHEDULE_A_MEETING
        : context.languageSet.INFO_COLLECTOR.FORM_SUBMISSION + '.';
  };

  const getDefaultWidgetsInfo = () => {
    let defaultWidgetsInfo =
      widgetsRedirectType ===
      VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES.POST_CALL_FAIL_WIDGETS
        ? [
            {
              type: VIDABOO_CONSTANTS.CALL_FAIL_TYPES.SCHEDULE_MEETING,
              text: getBtnText(
                VIDABOO_CONSTANTS.CALL_FAIL_TYPES.SCHEDULE_MEETING,
              ),
              image: getBtnImage(
                VIDABOO_CONSTANTS.CALL_FAIL_TYPES.SCHEDULE_MEETING,
                true,
              ),
            },
            {
              type: VIDABOO_CONSTANTS.CALL_FAIL_TYPES.INFO_COLLECTOR,
              text: getBtnText(
                VIDABOO_CONSTANTS.CALL_FAIL_TYPES.INFO_COLLECTOR,
              ),
              image: getBtnImage(
                VIDABOO_CONSTANTS.CALL_FAIL_TYPES.INFO_COLLECTOR,
              ),
            },
          ]
        : [];
    return defaultWidgetsInfo;
  };

  const getBtnImage = (type, isPrimary) => {
    const CommunicationTab = CommunicationIcons[getIconType(type)];
    return (
      <CommunicationTab
        showNewUI={!isPersonalPage}
        fillColor={
          // todo 2098 : Ilan/Jashan : color in case of team form?
          isPrimary
            ? 'var(--et-mentor-cta-primary-btn-text-color)'
            : isPersonalPage
              ? 'var(--et-mentor-cta-btn-primary-background-color-fc)'
              : 'var(--et-mentor-primary-text-color)'
        }
      />
    );
  };

  const getBtnText = (type) => {
    switch (type) {
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.TEXT_CHAT:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.TEXT_CHAT:
        return LANGUAGE_SET.CHAT;
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.WEBCALL:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.WEBCALL:
        return LANGUAGE_SET.WEBCALL;
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.WHATSAPP:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.WHATSAPP:
        return LANGUAGE_SET.WHATSAPP;
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.FB_MESSENGER:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.FB_MESSENGER:
        return LANGUAGE_SET.MESSENGER;
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.SCHEDULE_MEETING:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.SCHEDULE_MEETING:
        return LANGUAGE_SET.SCHEDULE;
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.INFO_COLLECTOR:
        return LANGUAGE_SET.MESSAGE;
      default:
        return '';
    }
  };

  const getIconType = (type) => {
    switch (type) {
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.TEXT_CHAT:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.TEXT_CHAT:
        return 'ChatIcon';
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.WEBCALL:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.WEBCALL:
        return 'VideoIcon';
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.WHATSAPP:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.WHATSAPP:
        return 'WhatsappIcon';
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.FB_MESSENGER:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.FB_MESSENGER:
        return 'MessengerIcon';
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.SCHEDULE_MEETING:
      case VIDABOO_CONSTANTS.FORM_SUBMIT_TYPES.SCHEDULE_MEETING:
        return 'ScheduleIcon';
      case VIDABOO_CONSTANTS.CALL_FAIL_TYPES.INFO_COLLECTOR:
        return 'FormIcon';
      default:
        return '';
    }
  };

  return (
    <div
      className={
        isPersonalPage
          ? 'et-personal-page-right-content-wrap'
          : 'et-widget-body-content-wrap'
      }>
      <div
        className={`et-widgets-redirect-container  ${isPersonalPage ? 'et-widget-redirect-container-pp' : ''}`}>
        {widgetsInfo.length > 0 ? (
          <>
            <div className="et-wrc-title-txt-wrap">
              <WidgetTitleComponent showAnim={true} title={message} />
            </div>
            <div className="et-widget-redirect-btns-wrap">
              {Object.values(widgetsInfo).map((widgetInfo, idx) => {
                return (
                  <div key={idx} className="et-widget-redirect-btn">
                    <ButtonComponent
                      text={widgetInfo.text}
                      onClick={() => onFooterOptionSelected(widgetInfo.type)}
                      type={
                        idx === 0
                          ? 'primary'
                          : isPersonalPage
                            ? 'primary-outlined'
                            : 'other'
                      }
                      image={widgetInfo.image}
                    />
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="et-widget-redirect-only-txt-wrap">
            <SuccessIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
            <div className="et-wrc-ot-text">{message}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetsRedirectComponent;
